/* eslint-disable no-unused-vars */
export enum USER_STATUS {
	NOT_INVITED = 'not_invited',
	INVITED = 'invited',
	ACCEPTED = 'accepted',
	INACTIVE = 'inactive',
}

export enum TASK_STATUS {
	TODO = 'to_do',
	IN_PROGRESS = 'in_progress',
	DONE = 'done',
}

export enum TASK_TYPE {
	SURVEY = 'survey',
	DATA = 'data',
	DELIVERABLE = 'deliverable',
	GENERAL = 'general',
}

export enum WORKFLOW_STATUS {
	SUBMISSION_PENDING = 'submission_pending',
	WORKING = 'working',
	NEEDS_ATTENTION = 'needs_attention',
	REQUIRES_RESUBMISSION = 'requires_resubmission',
	IN_REVIEW = 'in_review',
	AWAITING_FEEDBACK = 'awaiting_feedback',
	WAITING_ON = 'waiting_on',
	DONE = 'done',
}

export enum TASK_DUE_OPTION {
	OVERDUE = 'overdue',
	DUE_NEXT_WEEK = 'due_next_week',
}

export enum TASK_FLAG {
	NO_ASSIGNED_USERS = 'no_assigned_users',
	ASSIGNED_USERS_NOT_INVITED = 'assigned_users_not_invited',
	NO_ASSIGNED_APPROVER = 'no_assigned_approver',
}

export enum NOTIFICATION_TYPE {
	USER_MENTIONED_IN_TASK_NOTES = 'user_mentioned_in_task_notes',
	USER_MENTIONED_IN_TASK_SUMMARY = 'user_mentioned_in_task_summary',
	USER_MENTIONED_IN_DASHBOARD_SUMMARY = 'user_mentioned_in_dashboard_summary',
}

export enum PUSHER_EVENT {
	MANAGE_TASK = 'manage-task',
	DELETE_TASK = 'delete-task',
	MANAGE_DASHBOARD = 'manage-dashboard',
	DELETE_DASHBOARD = 'delete-dashboard',
	ADD_COMMENT_FOR_TASK = 'add-comment-for-task',
	DELETE_COMMENT_FOR_TASK = 'delete-comment-for-task',
	GET_FOLDER_FOR_TASK = 'get-folder-for-task',
	GET_NOTIFICATIONS = 'get-notifications',
	GET_SURVEY_RESULT = 'get-survey-result',
}

export enum SURVEY_TYPE {
	SURVEY = 'survey',
	DATA = 'data',
	EXTERNAL_SURVEY = 'external_survey',
}

export enum MILESTONE_STATUS {
	ACTIVE = 'active',
	COMPLETE = 'complete',
	INACTIVE = 'inactive',
}
